import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { EditOutlined, DeleteOutline } from "@mui/icons-material";
import Swal from "sweetalert2";
import GlobalButton from "../../../shared/utils/GlobalButton";

const RemarkModal = ({
  open,
  onClose,
  selectedApproval,
  remarkText,
  setRemarkText,
  isEditingRemark,
  setIsEditingRemark,
  uploadLoading,
  setUploadLoading,
  handleUpdateRemark,
  handleDeleteRemark,
  handleEditRemark,
}) => {
  const handleSave = () => {
    if (!remarkText.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Remark Required",
        text: "Please enter remark",
      });
      return;
    }
    handleUpdateRemark(remarkText);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { overflow: "hidden" },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 600,
        }}
      >
        {selectedApproval?.job?.remarks
          ? "Product Remark"
          : "Add Product Remark"}

        {selectedApproval?.job?.remarks && (
          <div className="flex items-center gap-2">
            <Tooltip title="Edit Remark">
              <IconButton
                size="small"
                onClick={handleEditRemark}
                sx={{
                  color: "#f59e0b",
                }}
              >
                <EditOutlined fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete Remark">
              <IconButton
                size="small"
                disabled={uploadLoading}
                onClick={handleDeleteRemark}
                sx={{
                  color: "#dc2626",
                }}
              >
                <DeleteOutline fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </DialogTitle>

      <DialogContent sx={{ overflow: "hidden" }}>
        <TextField
          fullWidth
          multiline
          rows={5}
          autoFocus
          value={remarkText}
          disabled={!isEditingRemark}
          onChange={(e) => {
            if (e.target.value.length <= 250) {
              setRemarkText(e.target.value);
            }
          }}
          placeholder="Enter remark..."
          sx={{
            mt: 1,
            "& textarea": {
              overflowX: "hidden",
            },
          }}
        />

        <Typography
          variant="caption"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 1,
            color: "#6b7280",
          }}
        >
          {remarkText.length}/250
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: "16px 24px", gap: 2 }}>
        <GlobalButton
          variant="secondary"
          size="medium"
          onClick={handleClose}
          style={{ width: "100px" }}
        >
          {`Close`}
        </GlobalButton>

        {isEditingRemark && (
          <GlobalButton
            variant="primary"
            size="medium"
            disabled={!remarkText.trim()}
            isLoading={uploadLoading}
            onClick={handleSave}
            style={{ width: "100px" }}
          >
            {selectedApproval?.job?.remarks ? "Update" : "Save"}
          </GlobalButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default RemarkModal;
